// Persists the taskIds already handed out by "Pick one for me" so a challenge
// doesn't win twice until its match pool is exhausted. The shared
// `useLocalStorage` hook is boolean-only, so this keeps a small string[] store.

const SERVED_KEY = 'help-me-pick:served-task-ids'

export const readServed = (): string[] => {
  try {
    const raw = window.localStorage.getItem(SERVED_KEY)
    if (raw === null) return []
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? (parsed as string[]) : []
  } catch {
    return []
  }
}

export const writeServed = (ids: string[]): void => {
  try {
    window.localStorage.setItem(SERVED_KEY, JSON.stringify(ids))
  } catch {
    // Ignore storage failures (private mode, quota) — non-repeat is best-effort.
  }
}
